export class AddressModel
{
    id = "";
    type  =  "";
    street1 = "";
    postalCode = "";
    country = "";
    city = "";
    stateProvince= "";
}